import React = require("react");
import { autoprefixer } from "../../material-ui/autoprefixer";
import {PositionBox} from 'diy/components/SyncPosition';

interface SpotLightProps extends React.Props<Spotlight> {
    maskBox: PositionBox;
    highlightBox: PositionBox;
    zIndex: number;
    showBorder?: boolean;
    onTouchTap?: () => void;
}

export default class Spotlight extends React.Component<SpotLightProps, {}> {

    static defaultProps = {
        showBorder: true
    };

    render() {
        const styles = this.getStyles();
        const { maskBox, highlightBox }  = this.props;

        // relative Highlight Box
        const relHighlightBox = {
            top: highlightBox.top - maskBox.top,
            left: highlightBox.left - maskBox.left,
            right: highlightBox.right - maskBox.right,
            bottom: highlightBox.bottom - maskBox.bottom,
            height: highlightBox.height,
            width: highlightBox.width
        };
        const topStyle = Object.assign({}, styles.mask, {
            height: relHighlightBox.top,
        });
        const leftStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top,
            height: relHighlightBox.height,
            right: relHighlightBox.right + relHighlightBox.width
        });
        const bottomStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top + relHighlightBox.height,
            bottom: 0
        });
        const rightStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top,
            left: relHighlightBox.left + relHighlightBox.width,
            height: relHighlightBox.height
        });
        const centerStyle = Object.assign({}, styles.center, {
            top: relHighlightBox.top,
            left: relHighlightBox.left,
            height: relHighlightBox.height,
            right: relHighlightBox.right
        });
        const rootStyle = Object.assign({}, styles.root, {
            top: maskBox.top,
            left: maskBox.left,
            bottom: maskBox.bottom,
            right: maskBox.right
        });
        return (
            <div onTouchTap={this.props.onTouchTap}
                style={rootStyle}>
                <div style={centerStyle}></div>
                <div style={topStyle}></div>
                <div style={leftStyle}></div>
                <div style={bottomStyle}></div>
                <div style={rightStyle}></div>
            </div>
        );
    }

    private getStyles() {
        return {
            root: autoprefixer({
                zIndex: this.props.zIndex,
                position: "absolute",
                userSelect: 'none',
                pointerEvents: "none"
            }),
            mask: {
                position: "absolute",
                background: "rgba(0,0,0,0.72)",
                cursor: 'pointer',
                zIndex: 1,
                top: 0,
                left: 0,
                right: 0,
                pointerEvents: "all"
            },
            center: {
                position: "absolute",
                pointerEvents: "none",
                border: this.props.showBorder ? "1px solid rgba(30,150,243,1)" : null,
                boxShadow: this.props.showBorder ? "0 0 7px 2px rgba(30,150,243,.3), inset 0 0 0px 1px #fff" : null,
                zIndex: 2
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/Spotlight.tsx
 **/